export default "__VITE_ASSET__Cj1ktmjJ__"